module.exports = __webpack_public_path__ + "73ca6ced76ac4de30ed8b5d8ccda076d.png";